// Shared navigation constants to avoid duplication
export const PAGE_LABELS: { [key: string]: string } = {
  'grammar': 'Grammar',
  'vocabulary': 'Vocabulary', 
  'reading': 'Reading',
  'writing': 'Writing'
};

export const NAV_PATHS = {
  HOME: '/',
  GRAMMAR: '/grammar',
  VOCABULARY: '/vocabulary',
  READING: '/reading',
  WRITING: '/writing'
} as const;
